<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-3"><a id="_idTextAnchor004"></a>Wave</h1>
<p class="Verse-first">The second wave hits the bleak and battered shore</p>
<p class="Verse-new">The flotsam is full of masks</p>
<p class="Verse-new">Different to the first wave before</p>
<p class="Verse-new">We had the summer to dance and have fun</p>
<p class="Verse-new">Now reality hits like a shot from a gun</p>
<p class="Verse-new">We jolt from our dreams</p>
<p class="Verse-new">Still stuck to our screens</p>
<p class="Verse-new">And remember the past</p>
<p class="Verse-new">And fear the future</p>
<p class="Verse-new">We all knew would come</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398433502_EPUB7.vue?15911266